module.exports = __webpack_public_path__ + "static/media/axss.a76afac0.png";